import ListingRecord from 'records/listing';
import { types as listingTypes } from 'redux/listing/reducer';
import { collectionReducer } from 'utils/reducerGenerator';

const updateListingSuccess = (state, { payload }) => {
    const listing = ListingRecord(payload.data);

    return state.set(
        'data',
        state.get('data').map((item) => {
            if (item.get('id') === listing.get('id')) {
                return listing;
            }

            return item;
        })
    );
};

export const { reducer, types } = collectionReducer(
    { namespace: 'LISTING', transformer: ListingRecord },
    {
        [listingTypes.PATCH_SUCCESS]: updateListingSuccess,
        [listingTypes.PUT_SUCCESS]: updateListingSuccess,
    }
);

export default reducer;
